import RestRepository from "../../infra/RestRepository";

export default class SlackInstallRepo extends RestRepository {
  constructor() {
    super("/api/slack-install");
  }
}
